import React, { useEffect, useState } from "react";
import style from "./globalstudentgparigorsummary.module.css";
import { Toast, ToastContainer } from "react-bootstrap";
import {
  getOverviewTexts,
  saveOverviewTexts,
  getGpaPercentAverages,
} from "../../../lib/studentcourselessonreport";
import { getColorClass ,getHeaderClass} from "./globalstudentgparigorsummary";

const levelClassMap = {
  Ovr: style.apCell,
  AP: style.apCell,
  HR: style.hrCell,
  CC: style.ccCell,
  EA: style.eaCell,
  RG: style.rgCell,
  OT: style.otCell,
};

export default function GlobalStudentCourseLessonAverageGpaReport({
  studentId,
  isStudent = false,
}) {
  const [data, setData] = useState({});
  const [overview, setOverview] = useState({});
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [allLevels, setAllLevels] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);

  useEffect(() => {
    loadData();
  }, [studentId]);

  const loadData = async () => {
    const gpaData = await getGpaPercentAverages(studentId);
    console.log("gpaData", gpaData);
    
    const overviewRes = await getOverviewTexts(studentId);

    const dataMap = {};
    const levelSet = new Set();
    const departmentSet = new Set();

    gpaData.forEach((item) => {
      const { department, studentId, ...rest } = item;
      if (!dataMap[department]) dataMap[department] = {};

      Object.entries(rest).forEach(([key, value]) => {
        // "Overall" -> "Ovr" çevir, diğerleri direkt kalsın
        const level = key;
        dataMap[department][level] = value ?? 0;
        levelSet.add(level);
      });

      departmentSet.add(department);
    });

    const overviewMap = {};
    overviewRes.forEach((item) => {
      overviewMap[item.type] = item.desc;
    });

    setData(dataMap);
    setOverview(overviewMap);
  // Custom sort order for levels
  const customOrder = ["AP", "CC", "HR", "EA", "RG", "OT"];
  const sortedLevels = customOrder.filter(lvl => levelSet.has(lvl));
  setAllLevels(["Overall", ...sortedLevels]);
    setAllDepartments([...departmentSet]);
  };

  const handleOverviewChange = (value) => {
    setOverview((prev) => ({ ...prev, caverageTest: value }));
  };

  const handleUpdate = async () => {
    await saveOverviewTexts(studentId, {
      caverageTest: overview.caverageTest || "",
    });
    setShowToast(true);
    setToastMessage("Update successful!");
    setTimeout(() => setShowToast(false), 3000);
    loadData();
  };

  const getAvg = (value) => (value != null ? parseFloat(value).toFixed(2) : "");

  return (
    <div className="card p-3">
      <div className="personal-info-head">
        <h4>GPA</h4>
        <ToastContainer
          style={{ top: "1rem", right: "1rem", position: "fixed" }}
        >
          <Toast
            show={showToast}
            onClose={() => setShowToast(false)}
            autohide
            delay={3000}
          >
            <Toast.Header>
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>

      {/*}<h5 className="mb-3">Average GPA (%)</h5>{*/}
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th style={{ width: "150px" }}>Department</th>
            {allLevels.map((lvl) => (
               <th key={lvl} className={getHeaderClass(lvl)}>{lvl}</th>
            ))}
            <th style={{ width: "400px" }}>Overview</th>
          </tr>
        </thead>
        <tbody>
          {allDepartments.map((dept, index) => (
            <tr key={dept}>
              <td>{dept}</td>
              {allLevels.map((lvl) => (
                <td
                  key={lvl}
                   className={data[dept]?.[lvl] > 0 ? getHeaderClass(lvl): ""}
                >
                  {getAvg(data[dept]?.[lvl])}
                </td>
              ))}

              {index === 0 && (
                <td
                  rowSpan={allDepartments.length}
                  className={style.overviewCell}
                >
                  <div className="h-100 w-100 d-flex flex-column justify-content-between">
                    {!isStudent ? (
                      <textarea
                        rows={allDepartments.length * 2}
                        className="form-control flex-grow-1"
                        style={{ resize: "none" }}
                        value={overview["caverageTest"] || ""}
                        onChange={(e) => handleOverviewChange(e.target.value)}
                      />
                    ) : (
                      <div className="bg-light border rounded p-2 flex-grow-1 overflow-auto">
                        {overview["caverageTest"]}
                      </div>
                    )}
                  </div>
                </td>
              )}
            </tr>
          ))}
          {/* Average row */}
          <tr style={{ fontWeight: 'bold', background: '#f0f0f0' }}>
            <td>Average</td>
            {allLevels.map((lvl) => {
              let avg = 0;
               if(lvl === "Overall") {
                // Collect all values except 'Overall' columns, only > 0
                const values = [];
                allDepartments.forEach(dept => {
                  Object.entries(data[dept] || {}).forEach(([key, value]) => {
                    if (key !== "Overall" && parseFloat(value) > 0) {
                      console.log(`Dept: ${dept}, Level: ${key}, Value: ${value}`);
                      values.push(parseFloat(value));
                    }
                  });
                });
                avg = values.length > 0 ? (values.reduce((sum, val) => sum + val, 0) / values.length).toFixed(2) : '';
              } else {
                const values = allDepartments.map(dept => parseFloat(data[dept]?.[lvl]) || 0).filter(val => val > 0);
                avg = values.length > 0 ? (values.reduce((sum, val) => sum + val, 0) / values.length).toFixed(2) : '';
              }
              return (
                <td key={lvl} className={avg > 0 ? getHeaderClass(lvl) : '' + ' fw-bold'}>{avg}</td>
              );
            })}
            {/* Empty cell for overview column */}
            <td></td>
          </tr>
        </tbody>
      </table>

      {!isStudent && (
        <div className="text-end">
          <button className="btn btn-primary" onClick={handleUpdate}>
            Update
          </button>
        </div>
      )}
    </div>
  );
}
